import { AGENDA, EVENT } from "@/data/site";
import { Coffee, Mic, Star, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import useDocumentTitle from "@/hooks/useDocumentTitle";

const ICONS = {
  break: Coffee,
  talk: Mic,
  keynote: Star,
};

export default function Agenda() {
  useDocumentTitle("Agenda", "Program mamy!kongres 2027 — TED-y prelegentek, warsztaty, panel dyskusyjny, mamy!DANCE.");
  return (
    <div>
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-8 pb-12">
        <div className="text-xs uppercase tracking-[0.3em] text-[#E6007A] mb-6">Agenda</div>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] mb-6">
          Jeden dzień. <br />Wielki <span className="italic text-[#E6007A]">plan</span>.
        </h1>
        <p className="text-lg text-[#5C534D]">
          {EVENT.dateLong} · {EVENT.city} · {EVENT.hours}
        </p>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 pb-24">
        <ol className="relative border-l-2 border-[#E8E1D9] ml-4">
          {AGENDA.map((item, i) => {
            const Icon = ICONS[item.type] || Mic;
            const isBreak = item.type === "break";
            return (
              <li key={i} className="relative pl-10 pb-10" data-testid={`agenda-${i}`}>
                <span className={`absolute -left-[13px] top-2 w-6 h-6 rounded-full grid place-items-center ${
                  isBreak ? "bg-[#F4EFE6] text-[#5C534D]" : i % 2 ? "bg-[#2E4331] text-white" : "bg-[#E6007A] text-white"
                }`}>
                  <Icon className="w-3 h-3" />
                </span>
                <div className={`rounded-2xl p-6 ${isBreak ? "bg-[#F4EFE6]" : "bg-white border border-[#E8E1D9]"}`}>
                  <div className="flex flex-wrap items-baseline gap-3 mb-1">
                    <span className="text-sm font-semibold text-[#E6007A] tracking-wide">{item.time}</span>
                  </div>
                  <div className="font-display text-xl md:text-2xl leading-tight text-[#2B2623]">{item.title}</div>
                </div>
                {item.sub && (
                  <div
                    data-testid={`agenda-${i}-sub`}
                    className="mt-3 ml-6 rounded-xl bg-[#FDDAE3] border border-[#F4B7CA] px-5 py-3 text-sm font-medium text-[#E6007A]"
                  >
                    {item.sub}
                  </div>
                )}
              </li>
            );
          })}
        </ol>

        <div className="mt-16 text-center">
          <Link
            to="/zapisz-sie"
            data-testid="agenda-cta-register"
            className="btn-lift inline-flex items-center gap-3 rounded-full bg-[#E6007A] px-10 py-5 text-white font-semibold text-lg"
          >
            Wchodzę w to — zapisy na warsztaty
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
}
